import { logoutClearStore } from '@utils/functions';
import { getToken } from '@utils/tokenStorage';
import axios from 'axios';

import { authLogoutSuccess } from '@/store/slices/auth/authSlice';

import { store } from '../App';
import { BASE_URL } from './constants';

// const BaseUrlLocal = 'http://localhost:51201';
const BaseUrlProd = 'https://unilink.us';
const BaseUrlDev = 'https://unilink-web-dev.azurewebsites.net';
// const BaseUrlProdTest = 'https://testunilink.azurewebsites.net';
// const BaseUrlProd = 'https://cors-anywhere.herokuapp.com/https://unilink.us';
export const BaseUrlShort = 'unilink.us';

export const BaseUrl = BASE_URL;

const CancelToken = axios.CancelToken;
export const source = CancelToken.source();

const defaultOptions = {
  baseURL: BaseUrl,
  headers: {
    'Content-Type': 'application/json', // 'application/x-www-form-urlencoded'
  },
};

let instance = axios.create(defaultOptions);

instance.interceptors.request.use((config) => {
  const token = getToken();
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

instance.interceptors.response.use(
  (config) => config,
  (error) => {
    const statusCode = error.response?.status;
    const requestUrl = error.config?.url || '';

    // 401 on admin endpoints = no admin access, not an invalid token — don't logout
    const isAdminEndpoint = requestUrl.includes('/api/admin/') || requestUrl.includes('api/admin/');

    if (statusCode === 401 && !isAdminEndpoint) {
      const currentToken = store.getState().auth.token;

      if (currentToken) {
        store.dispatch(authLogoutSuccess());
        logoutClearStore();
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
